import { Card } from "@/components/ui/card";
import sparkLogo from "@/assets/spark-logo.webp";
import sparkChildren from "@/assets/spark-children.webp";

interface SparkSectionProps {
  showJourneyText?: boolean;
}

const SparkSection = ({ showJourneyText = true }: SparkSectionProps) => {
  return (
    <div className="animate-fade-in">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
        {/* Cream frame */}
        <div className="rounded-3xl p-8 overflow-hidden bg-[#fffdd0] shadow-spark-frame">
            <Card className="overflow-hidden transition-all border-0 shadow-none rounded-3xl bg-transparent">
              <div className="grid md:grid-cols-2 gap-0">
                {/* Left Column - Abstract Wavy Pattern with Image */}
                <div className="relative p-12 flex items-center justify-center overflow-hidden min-h-[500px] rounded-3xl">
                  {/* Abstract wavy background */}
                  <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 500" preserveAspectRatio="xMidYMid slice">
                    {/* Lime green wave top */}
                    <path d="M0,0 L400,0 L400,180 Q300,220 200,180 T0,180 Z" fill="#C8E65C" />
                    
                    {/* Purple wave middle-top */}
                    <path d="M0,80 Q100,140 200,100 T400,100 L400,320 Q300,280 200,320 T0,320 Z" fill="#9333EA" />
                    
                    {/* Teal wave bottom */}
                    <path d="M0,280 Q100,320 200,280 T400,280 L400,500 L0,500 Z" fill="#14B8A6" />
                    
                    {/* Additional purple accent wave */}
                    <path d="M0,200 Q100,240 200,200 T400,200 L400,400 Q300,440 200,400 T0,400 Z" fill="#7C3AED" />
                  </svg>
                  {/* Image without circular border */}
                  <div className="relative z-10">
                    <img
                      src={sparkChildren}
                      alt="Children learning and playing together at The Children's Hour Academy"
                      className="w-[600px] h-[600px] object-cover"
                      loading="lazy"
                      decoding="async"
                      width={1038}
                      height={1019}
                    />
                  </div>
                </div>

                {/* Right Column - Content Card */}
                <div className="p-8 md:p-12 flex flex-col justify-center border-0 rounded-3xl bg-[#fffdd0]">
                  <div className="mb-2">
                    {showJourneyText && (
                      <p className="text-[#2C003E] font-semibold text-sm mb-2">Our Spark Journey</p>
                    )}
                    <h2 className="font-header text-2xl font-bold text-[#2C003E] mb-6 md:text-lg">
                      Recognized with Oregon's SPARK 5-Star Quality Rating
                    </h2>
                  </div>
                  
                  <div className="mb-6">
                    <img
                      src={sparkLogo}
                      alt="SPARK Early Learning Quality Rating and Improvement System"
                      className="h-16 w-auto"
                      loading="lazy"
                      decoding="async"
                      width={101}
                      height={60}
                    />
                  </div>
                  
                  <p className="text-[#2C003E] mb-6 leading-relaxed">
                    At Children's Hour Academy, Spark isn't just a certificate on the wall. It's a reflection of how we walk alongside children and families each day. For us, every child's path is a pilgrimage, full of wonder, discovery, and growth. Families aren't visitors here; they are friends, and CHA becomes an extension of their home.
                  </p>
                  
                  <p className="text-[#2C003E] italic text-sm leading-relaxed">
                    SPARK is Oregon's Quality Rating and Improvement System (QRIS). It serves a similar purpose to national accreditations, such as NAEYC, by highlighting high standards in early education.
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SparkSection;